import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { WorkflowService } from 'src/app/_services/workflow.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ErrorUtil } from 'src/app/_utilities/error';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { TreeNode } from 'primeng/api';
import * as _ from 'lodash';
@Component({
    selector: 'app-add-existing-notification',
    templateUrl: './add-existing-notification.component.html',
    standalone: false
})
export class AddExistingNotificationComponent implements OnInit {
  title: any 
  selectedNotification: any[];
  data: any;
  workflowData: any;
  addNotificationForm: UntypedFormGroup;
  submitTouched: boolean=false;
  translate: any;
  datas: TreeNode[];
  filteredWorkflowData: any[];
selectedNotificationData: any;
  deferredSelection: any[] | null = null;
  redirectUrl: string = 'dashboard/setup/workflows/view';
  constructor(
    public modalRef: BsModalRef,
    private route: Router,
    private workflowService: WorkflowService,
    private spinner: NgxSpinnerService,
    private errorUtil: ErrorUtil,
    private languageTranslateService: LanguageTranslateService,
  ) {
    this.addNotificationForm = new UntypedFormGroup({
      'name': new UntypedFormControl(null, [Validators.required,Validators.maxLength(40)]),
   });
  }

  ngOnInit(): void {
    console.log(this.data)
    if(this.data.redirectUrl){
      this.redirectUrl = this.data.redirectUrl;
    } else {
      this.redirectUrl = 'dashboard/setup/workflows/view';
    }
     this.languageTranslateService.wordSrc$.subscribe(transData => { 
          if(Object.keys(transData).length != 0){
            this.translate = transData
            this.title = this.translate?.setup.workflows.sections.sec7.singular
          }
      })

      this.workflowService.getListOfWorkflowsNotification(this.data.triggerModule, this.data.typeMode).subscribe((data: any) => {
        console.log(data);
        this.workflowData = data.body;
      
        if (this.data.workflowWorkflowAlerts) {
          // Map selected notifications based on `workflowWorkflowAlerts`
           this.selectedNotificationData = this.data.workflowWorkflowAlerts.map((alert: any) =>
            this.workflowData.find((wf: any) => wf.id === alert.id)
          );
      
          // Remove undefined values if any mapping doesn't find a match
          _.remove(this.selectedNotificationData, (n: any) => n == undefined);
          console.log('Selected Notifications:', this.selectedNotificationData)
      
          // Filter out already selected notifications from the dropdown list
          this.filteredWorkflowData = this.workflowData.filter(
            (wf: any) => !this.selectedNotificationData.some((selected: any) => selected?.id === wf.id)
          );
      
          console.log('Filtered Workflow Data:', this.filteredWorkflowData);
        } else {
          // If no alerts, use the full list
          this.filteredWorkflowData = [...this.workflowData];
        }
      });
      

  }

  newNotification(){
    console.log(this.data)
    this.modalRef.hide()
    if(this.data.typeMode == 'Email'){
      this.route.navigate(['dashboard/setup/action/notifications/createEmail'],{ queryParams: { workFlowId: this.data.id,triggerModule:this.data.triggerModule,redirectUrl: this.redirectUrl },})
    }else{
      this.route.navigate(['dashboard/setup/action/notifications/createApp'],{ queryParams: { workFlowId: this.data.id ,triggerModule:this.data.triggerModule,redirectUrl: this.redirectUrl },})
    }
  }
  newEmailTemplate(){
    this.modalRef.hide()
    this.route.navigate(['dashboard/setup/templates/email/create'])
  }
    /****************************************** Submit Data *****************************/
    onSubmitForm(){
   
   
      this.submitTouched = true;
      if(!this.addNotificationForm.valid){
        for (var i in this.addNotificationForm.controls) {
          console.log(this.addNotificationForm.controls[i])
          this.addNotificationForm.controls[i].markAsTouched();
        }
  
        this.spinner.hide();
  
        this.submitTouched = false;
        return false;
      }
     
  
      const selected = this.addNotificationForm.get('name')?.value ?? this.selectedNotification;
      const req = (Array.isArray(selected) ? selected : (selected ? [selected] : [])).map((item: any) => {
        const copy = { ...item };
        if (this.data?.markNotificationsNew) {
          copy.isNew = true;
        }
        if (copy.deleted == null) {
          delete copy.deleted;
        }
        if (copy.new == null) {
          delete copy.new;
        }
        return copy;
      });

      console.log(req,"req",this.data)
      if (this.data?.deferSave) {
        this.deferredSelection = req;
        this.modalRef.hide();
        return;
      }
      this.spinner.show();
      this.workflowService.updateNotificationIdWorkFlow(req,this.data.id).subscribe((res:any) => {
        console.log("Response ", res);
        if(res.status == 201 || res.status == 200){
          this.errorUtil.setErrorMessage(200, this.translate?.general.messages.updatedSuccessfully ,  null, 'success',3000);
          this.modalRef.hide();
        } else {
          this.errorUtil.setErrorMessage(res.status, null ,  res.error.title, 'error',3000);
          this.submitTouched = false;
        }
      })
    
    this.spinner.hide();
    
    }
}
